import { ChangeEvent } from 'react';
import { CircularProgress, Pagination } from '@mui/material';
import { BoletoProtheus } from '../../../interfaces/entities/BoletoProtheus';
import { Titulo } from '../../../interfaces/entities/Titulo';
import TabelaTitulos from './TabelaTitulos';
import { sxPagination } from './sxProps';
import { sxPaginationContrast } from '../../../assets/styles/CommonSxProps';
import { scrollTo } from '../../../utils/ScrollUtil';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

interface AbaFaturaProps {
  faturas: BoletoProtheus[];
  loading: boolean;
  page: number;
  onPageChange: (event: ChangeEvent<unknown>, newPage: number) => void;
  onDownloadFaturaClicked: (id: string) => void;
  paginationLength: number;
}

function AbaFatura({
  faturas,
  loading,
  page,
  onPageChange,
  onDownloadFaturaClicked,
  paginationLength
}: AbaFaturaProps) {
  const accessibility = useAccessibility();

  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    onPageChange(event, newPage);
    scrollTo('scroll-ref');
  };

  const paginatedFaturas = faturas
    .slice((page - 1) * paginationLength, page * paginationLength)
    .map((item) => ({
      idTitulo: item.numero,
      dtEmissao: item.emissao,
      dtVencimento: item.vencimento
    })) as Titulo[];

  const totalItems = faturas.length;
  const isEmpty = !faturas.length;

  if (loading) {
    return (
      <div className='loading-holder'>
        <CircularProgress />
      </div>
    );
  }

  if (isEmpty) {
    return null;
  }

  return (
    <div id='scroll-ref'>
      <TabelaTitulos
        data={paginatedFaturas}
        onVisualizarClicked={onDownloadFaturaClicked}
        buttonLabel='Ver fatura'
        columnLabel='Título'
      />

      {totalItems > paginationLength && (
        <Pagination
          className='pagination-holder'
          count={Math.ceil(totalItems / paginationLength)}
          sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination}
          hideNextButton
          hidePrevButton
          color='primary'
          page={page}
          onChange={handlePageChange}
        />
      )}
    </div>
  );
}

export default AbaFatura;
